import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {ApiError, CountriesService} from "@esa/api";
import {CountriesActions} from "../actions";
import {catchError, mergeMap, of, map} from "rxjs";
import {ApiErrorHandlerService} from "../../services/api-error-handler.service";


@Injectable()
export class CountriesEffects {

  getCountries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CountriesActions.getCountries),
      mergeMap(({}) => this._countriesService.getApiCountry().pipe(
        map(response => CountriesActions.getCountriesSuccess({ countries: response })),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, CountriesActions.getCountriesError());
        })
      ))
    );
  });

  constructor(
    private actions$: Actions,
    private _countriesService: CountriesService,
    private apiErrorHandlerService: ApiErrorHandlerService
  ) {}
}
